import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../../../../api/api";
import { Link } from "react-router";
import { defult_profile_pic } from "../../../../../../assets/images/images";
import FilteredInput from "../../../../../../components/FilteredInput/FilteredInput";
import ai_assistant from "../../../../../../assets/images/ai_assistant.svg"
import moment from 'moment';
import { marked } from "marked";
import PreprocessAndRenderLatex from "../../../../../../components/ProcessRenderLatex";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";
import useBranding from "../../../../../../hooks/useBranding";


const Message = () => {
  const [getEnrollStudent, setGetEnrollStudent] = useState({});
  const [getuserid, setuserid] = useState();
  const [getstatuspopup, setstatuspopup] = useState(false);
  const [getstudentname, setstudentname] = useState("");
  const [getstudentimage, setstudentimage] = useState("");
  const [getchathistory, setchathistory] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [lastMessages, setLastMessages] = useState({});
  const dispatch = useDispatch();
  const { token } = useAuth();
  const globalState = useSelector((state) => state.globalState);
  const teacherProfile = globalState?.teacher_details?.data?.ai_avatar;
  const chatContainerRef = useRef(null);
  const branding = useBranding();
  useEffect(() => {
    if (getchathistory.length > 0 && chatContainerRef.current) {
      setTimeout(() => {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }, 100);
    }
  }, [getchathistory]);
  useEffect(() => {
    if (token) {
      api
        .get("/auth/teacher/get-student-chat-list/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {

            if (response?.data) {
              setGetEnrollStudent(response?.data?.data);
            }
          }
        })
        .catch((error) => { });

      api
        .get("/auth/get-user-id/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response?.data?.status === 200) {
            setuserid(response?.data?.user_id);
          }
        })
        .catch((error) => {
          //
        });
    }
  }, []);
  useEffect(() => {
    if (getEnrollStudent.length > 0) {
      getEnrollStudent.forEach((student) => {
        const datadtl = {
          student_user_id: student.user,
          teacher_user_id: getuserid,
        };

        const url_chatbot = "/ai/api/student_chat_history/";
        api
          .post(url_chatbot, datadtl)
          .then((response) => {
            const chatData = response?.data?.data;
            if (chatData && chatData.length > 0) {
              const lastIndex = chatData.length - 1;
              const lastMessageAnswer = chatData[lastIndex].answer;
              const lastMessageTime = chatData[lastIndex].created_at;

              // Storing last message data for each student
              setLastMessages((prev) => ({
                ...prev,
                [student.user]: {
                  message: lastMessageAnswer,
                  time: lastMessageTime,
                },
              }));
            }
          })
          .catch((error) => { });
      });
    }
  }, [getEnrollStudent, getuserid]);

  const chatopenfn = (student_id, studentname, student_image) => {
    setSelectedStudentId(student_id);
    setstudentname(studentname);
    setstudentimage(student_image);
    const datadtl = {
      student_user_id: student_id,
      teacher_user_id: getuserid,
    };

    const url_chatbot = "/ai/api/student_chat_history/";
    api
      .post(url_chatbot, datadtl)
      .then((response) => {
        setchathistory(response?.data?.data);
        setstatuspopup(true);
      })
      .catch((error) => { });
  };

  const [search, setSearch] = useState("");
  const serachhandleInputChange = (event) => {
    const { value } = event.target;
    setSearch(value);
  };

  // Function to format timestamp using moment.js
  const formatTimeWithMoment = (timestamp) => {
    return moment(timestamp).format('hh:mm A'); // Example: "06:08 AM"
  };

  const formatDateWithMoment = (timestamp) => {
    return moment(timestamp).format('DD MMM'); // Example: "17 Sep"
  };

    useEffect(()=>{
      return(() => {
        dispatch(setDrawerState(false));
      });
    },[])

  return (
    <>
      <div className="msg_sec_new">
        <div className="msg_sec_new_body_inner">
          <div className="msg_sec_new_body_inner_left">
            <div className="msg_left_search">
              <i className="fas fa-search"></i>
              <input
                type="search"
                value={search}
                onChange={serachhandleInputChange}
                placeholder="Search here"
              />
            </div>
            <div className="msg_sec_new__left_body">
              {Array.isArray(getEnrollStudent) ? (
                getEnrollStudent
                  .filter((studentdts) => {
                    // Filter by search
                    let searchMatch = true;
                    if (search) {
                      searchMatch = studentdts?.name
                        ?.toLowerCase()
                        .includes(search?.toLowerCase());
                    }

                    return searchMatch;
                  })
                  .map((studentdts, index) => {
                    const lastMessageData = lastMessages[studentdts.user];

                    return (
                      <div
                        className={`msg_sec_new__left_single ${selectedStudentId === studentdts.user ? "active" : ""
                          }`}
                        onClick={() =>
                          chatopenfn(
                            studentdts.user,
                            studentdts.name,
                            studentdts.student_profile_pic
                          )
                        }
                        onDragStart={(e) => e.preventDefault()}
                      >
                        <Link className="msg_sec_new__left_single_inner">
                          <img src={studentdts.student_profile_pic ? studentdts.student_profile_pic : defult_profile_pic} alt="" />
                          <div className="msg_data_sec">
                            <div className="msg_data_sec_top">
                              <h6>{studentdts.name}</h6>
                              <div className="last-chat-timestamp">{lastMessageData?.time ? formatTimeWithMoment(lastMessageData.time) : ""}</div>
                            </div>

                            <p className="last-chat-message"> {lastMessageData?.message ? lastMessageData?.message.replace(/###|####|#|---|\*\*/g, '') : ""}</p>
                          </div>
                        </Link>
                      </div>
                    )
                  })
              ) : (
                <p>No chat found.</p> // Or any other fallback UI
              )}
            </div>
          </div>
          <div className="msg_sec_new_body_inner_right">
            {getstatuspopup ? (
              <>
                <div className="right_chat_sec_new">
                  <div className="right_chat_sec_new_head">
                    <img src={getstudentimage ? getstudentimage : defult_profile_pic} alt="" />
                    <span>
                      <h6>{getstudentname}</h6>
                    </span>
                  </div>
                  <div className="right_chat_sec_new_body_sec" ref={chatContainerRef}>
                    {getchathistory.length > 0 ? (
                      getchathistory.map((chatdtls, index) => {
                        const previousCourseName = index > 0 ? getchathistory[index - 1].course_name : null;
                        const currentCourseName = chatdtls.course_name;
                        const previousChatType = index > 0 ? getchathistory[index - 1].chat_type : null;
                        const currentChatType = chatdtls.chat_type;

                        const courseNameChanged = previousCourseName !== currentCourseName;
                        const chatTypeChanged = previousChatType !== currentChatType;
                        const showContextChange = index === 0 || courseNameChanged || chatTypeChanged;

                        // Determine what message to show
                        let contextMessage = "";
                        if (showContextChange) {
                          if (courseNameChanged && currentCourseName && currentChatType) {
                            contextMessage = `The context for this conversation has been updated to ${currentCourseName} `;
                          } else if (courseNameChanged && currentCourseName) {
                            contextMessage = `The context for this conversation has been updated to ${currentCourseName}`;
                          } else if (chatTypeChanged && currentCourseName === null) {
                            contextMessage = `The context for this conversation has been updated to ${currentChatType}`;
                          }
                        }
                        return (
                          <>
                            {showContextChange && contextMessage && (
                              <div className="line-wrapper"><span>{contextMessage}</span></div>
                            )}
                            <div
                              key={`left_${index}`}
                              className="right_chat_sec_left"
                            >
                              <img src={getstudentimage ? getstudentimage : defult_profile_pic} alt="Chat" />
                              <span>
                                <span>{chatdtls.query}</span>
                                <div className="user-chat-timestamp">{formatDateWithMoment(chatdtls.created_at)}, {formatTimeWithMoment(chatdtls.created_at)}</div>
                              </span>
                            </div>
                            <div
                              key={`right_${index}`}
                              className="right_chat_sec_right"
                            >
                              {/* <img src={teacherProfile ? teacherProfile : defult_profile_pic} alt="Teach" /> */}
                              <img src={ai_assistant} alt="Chat" />
                              <div className="ai_chat_arrow">
                                <div className="ai_chat_info">
                                  <span className="ai-sender-name">{branding.AIAssiastantSenderName} - {chatdtls.chat_type}</span>
                                  <div className="ai-chat-subject">{chatdtls.course_name || "General AI Assistant"}</div>
                                  <div className="ai-chat-timestamp">
                                    <div>{formatDateWithMoment(chatdtls.created_at)}</div>
                                    <div>{formatTimeWithMoment(chatdtls.created_at)}</div>
                                  </div>
                                </div>
                                <span className="ai_chat_message">
                                  {<PreprocessAndRenderLatex
                                    content={marked(chatdtls.answer || "")}
                                    isBlockMath={true}
                                  />}
                                </span>
                              </div>

                            </div>
                          </>
                        )
                      })
                    ) : (
                      <p>No Messages found.</p> // Or any other fallback UI
                    )}
                  </div>
                </div>
              </>
            ) : (
              <p style={{ padding: "26px", color: "#909090" }}>No chat found.</p>
            )}
          </div>
        </div>
        <FloatingAIButton
          onClick={() => {
            dispatch(setDrawerState(!chatDrawerState.isOpen));
            dispatch(setIsWebAllowed(true));
            dispatch(setQueryMetaData(null));
          }}
        />
      </div>
    </>
  );
};

export default Message;